import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { StarIcon, QuoteIcon } from 'lucide-react';
export function Testimonials() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-80px'
  });
  return <section ref={ref} className="w-full bg-[#0a0a0a] py-28 px-6" data-id="element-192">
      <div className="max-w-5xl mx-auto" data-id="element-193">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.7
      }} className="text-center mb-16" data-id="element-194">
          <p className="text-[#CF9B2E] uppercase tracking-[0.3em] text-sm font-bold mb-4 font-['Lato']" data-id="element-195">
            Lo que dicen los lectores
          </p>
          <h2 className="text-4xl md:text-5xl font-bold text-[#F5F0E8] mb-6" data-id="element-196">
            Voces que lo leyeron
          </h2>
          <div className="gold-divider" data-id="element-197" />
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-198">
          {/* Testimonial 1 */}
          <motion.div initial={{
          opacity: 0,
          y: 40
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.7,
          delay: 0.1
        }} className="bg-[#111111] border border-[#1e1e1e] p-8 rounded-sm relative" data-id="element-199">
            <QuoteIcon className="w-8 h-8 text-[#CF9B2E]/30 absolute top-6 right-6" data-id="element-200" />
            <div className="flex gap-1 mb-4" data-id="element-201">
              <StarIcon className="w-4 h-4 fill-[#CF9B2E] text-[#CF9B2E]" data-id="element-202" />
              <StarIcon className="w-4 h-4 fill-[#CF9B2E] text-[#CF9B2E]" data-id="element-203" />
              <StarIcon className="w-4 h-4 fill-[#CF9B2E] text-[#CF9B2E]" data-id="element-204" />
              <StarIcon className="w-4 h-4 fill-[#CF9B2E] text-[#CF9B2E]" data-id="element-205" />
              <StarIcon className="w-4 h-4 fill-[#CF9B2E] text-[#CF9B2E]" data-id="element-206" />
            </div>
            <p className="text-[#E8D5B0] leading-relaxed mb-6 text-lg" style={{
            fontFamily: 'Playfair Display, serif',
            fontStyle: 'italic'
          }} data-id="element-207">
              "Por fin alguien cuenta lo que vivimos en venezuela. Es excelente"
            </p>
            <div className="flex items-center gap-3" data-id="element-208">
              <div className="w-10 h-10 rounded-full bg-[#C0392B]/30 flex items-center justify-center text-[#C0392B] font-bold text-lg" data-id="element-209">
                C
              </div>
              <div data-id="element-210">
                <p className="text-[#F5F0E8] font-bold text-sm" data-id="element-211">Carlos M.</p>
                <p className="text-[#9A9080] text-xs" data-id="element-212">Miami</p>
              </div>
            </div>
          </motion.div>

          {/* Testimonial 2 */}
          <motion.div initial={{
          opacity: 0,
          y: 40
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.7,
          delay: 0.25
        }} className="bg-[#111111] border border-[#CF9B2E]/20 p-8 rounded-sm relative" data-id="element-213">
            <QuoteIcon className="w-8 h-8 text-[#CF9B2E]/30 absolute top-6 right-6" data-id="element-214" />
            <div className="flex gap-1 mb-4" data-id="element-215">
              <StarIcon className="w-4 h-4 fill-[#CF9B2E] text-[#CF9B2E]" data-id="element-216" />
              <StarIcon className="w-4 h-4 fill-[#CF9B2E] text-[#CF9B2E]" data-id="element-217" />
              <StarIcon className="w-4 h-4 fill-[#CF9B2E] text-[#CF9B2E]" data-id="element-218" />
              <StarIcon className="w-4 h-4 fill-[#CF9B2E] text-[#CF9B2E]" data-id="element-219" />
              <StarIcon className="w-4 h-4 fill-[#CF9B2E] text-[#CF9B2E]" data-id="element-220" />
            </div>
            <p className="text-[#E8D5B0] leading-relaxed mb-6 text-lg" style={{
            fontFamily: 'Playfair Display, serif',
            fontStyle: 'italic'
          }} data-id="element-221">
              "Un relato que te eriza la piel. Es la verdad que todos los
              venezolanos necesitamos que el mundo lea."
            </p>
            <div className="flex items-center gap-3" data-id="element-222">
              <div className="w-10 h-10 rounded-full bg-[#CF9B2E]/30 flex items-center justify-center text-[#CF9B2E] font-bold text-lg" data-id="element-223">
                E
              </div>
              <div data-id="element-224">
                <p className="text-[#F5F0E8] font-bold text-sm" data-id="element-225">Elena R.</p>
                <p className="text-[#9A9080] text-xs" data-id="element-226">Madrid</p>
              </div>
            </div>
          </motion.div>

          {/* Testimonial 3 */}
          <motion.div initial={{
          opacity: 0,
          y: 40
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.7,
          delay: 0.4
        }} className="bg-[#111111] border border-[#1e1e1e] p-8 rounded-sm relative" data-id="element-227">
            <QuoteIcon className="w-8 h-8 text-[#CF9B2E]/30 absolute top-6 right-6" data-id="element-228" />
            <div className="flex gap-1 mb-4" data-id="element-229">
              <StarIcon className="w-4 h-4 fill-[#CF9B2E] text-[#CF9B2E]" data-id="element-230" />
              <StarIcon className="w-4 h-4 fill-[#CF9B2E] text-[#CF9B2E]" data-id="element-231" />
              <StarIcon className="w-4 h-4 fill-[#CF9B2E] text-[#CF9B2E]" data-id="element-232" />
              <StarIcon className="w-4 h-4 fill-[#CF9B2E] text-[#CF9B2E]" data-id="element-233" />
              <StarIcon className="w-4 h-4 fill-[#CF9B2E] text-[#CF9B2E]" data-id="element-234" />
            </div>
            <p className="text-[#E8D5B0] leading-relaxed mb-6 text-lg" style={{
            fontFamily: 'Playfair Display, serif',
            fontStyle: 'italic'
          }} data-id="element-235">
              "Increíble análisis. Este libro es un pecado no tenerlo. Es
              historia pura."
            </p>
            <div className="flex items-center gap-3" data-id="element-236">
              <div className="w-10 h-10 rounded-full bg-[#1A5276]/40 flex items-center justify-center text-[#4A90C4] font-bold text-lg" data-id="element-237">
                R
              </div>
              <div data-id="element-238">
                <p className="text-[#F5F0E8] font-bold text-sm" data-id="element-239">Ricardo V.</p>
                <p className="text-[#9A9080] text-xs" data-id="element-240">Bogotá</p>
              </div>
            </div>
          </motion.div>

          {/* Testimonial 4 — Internacional */}
          <motion.div initial={{
          opacity: 0,
          y: 40
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.7,
          delay: 0.55
        }} className="bg-[#111111] border border-[#1A5276]/20 p-8 rounded-sm relative" data-id="element-241">
            <QuoteIcon className="w-8 h-8 text-[#CF9B2E]/30 absolute top-6 right-6" data-id="element-242" />
            <div className="flex gap-1 mb-4" data-id="element-243">
              <StarIcon className="w-4 h-4 fill-[#CF9B2E] text-[#CF9B2E]" data-id="element-244" />
              <StarIcon className="w-4 h-4 fill-[#CF9B2E] text-[#CF9B2E]" data-id="element-245" />
              <StarIcon className="w-4 h-4 fill-[#CF9B2E] text-[#CF9B2E]" data-id="element-246" />
              <StarIcon className="w-4 h-4 fill-[#CF9B2E] text-[#CF9B2E]" data-id="element-247" />
              <StarIcon className="w-4 h-4 fill-[#CF9B2E] text-[#CF9B2E]" data-id="element-248" />
            </div>
            <p className="text-[#E8D5B0] leading-relaxed mb-6 text-lg" style={{
            fontFamily: 'Playfair Display, serif',
            fontStyle: 'italic'
          }} data-id="element-249">
              "No soy venezolano, pero este libro me abrió los ojos sobre cómo
              las potencias operan en la sombra. Fascinante y aterrador a la
              vez."
            </p>
            <div className="flex items-center gap-3" data-id="element-250">
              <div className="w-10 h-10 rounded-full bg-[#1A5276]/30 flex items-center justify-center text-[#4A90C4] font-bold text-lg" data-id="element-251">
                J
              </div>
              <div data-id="element-252">
                <p className="text-[#F5F0E8] font-bold text-sm" data-id="element-253">Javier L.</p>
                <p className="text-[#9A9080] text-xs" data-id="element-254">
                  Analista Político, Madrid
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}